import LimitedReactMarkdown from './LimitedReactMarkdown'

export default LimitedReactMarkdown
